import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import HighchartsVue from "highcharts-vue";
import api from './api'

Vue.config.productionTip = false;


/**
 * Set up axios instance
 * @type {AxiosInstance}
 */
Vue.prototype.$http = api;
api.defaults.timeout = 10000;
api.interceptors.response.use(
response => {
    if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        if (error.response.status) {
            let errorCode;
            // Switch in case different errors should be handled differently
            switch (error.response.status) {
                case 401:
                    errorCode = 'Http Response 401';
                    sessionStorage.removeItem('loggedIn')
                    break;
                case 403:
                    errorCode = 'Http Response 403';
                    sessionStorage.removeItem('loggedIn')
                    break;
                default:
                    errorCode = 'Http Response ' + error.response.status
                    break;
            }
            errorCode += ' - ' + error.response.statusText
            const errorError = error.response.data.error ? ' - ' + error.response.data.error + '\n' : '\n';
            const errorMessage = error.response.data.message ? 'Message: ' + error.response.data.message + '\n' : '';
            const errorDescription = error.response.data.description ? 'Description: ' + error.response.data.description : '';
            store.commit('setErrorMessage', errorCode + errorError + errorMessage + errorDescription)
            return Promise.reject(error.response);
        }
    }
);

Vue.config.productionTip = false
Vue.use(HighchartsVue);


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
